/* posterarte.home.js — Homepage POSTERARTE · Vanilla JS · ~2KB · Zero deps
   Activa: animaciones scroll · counter reviews · FAQ · newsletter */

(function () {
  'use strict';

  /* ── GUARD: prevent double execution if script is ever loaded twice ── */
  if (window._paHomeLoaded) return;
  window._paHomeLoaded = true;

  /* ── 4. FAQ acordeón — event delegation ─────────────────────────
     Attached to document (not individual buttons) so it survives
     Shopify section re-renders in the theme editor.
     CSS handles the transition via max-height; JS only toggles
     the is-open class and keeps aria-expanded in sync.          */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pa-faq__btn');
    if (!btn) return;

    var faq    = btn.closest('.pa-faq');
    var isOpen = faq.classList.contains('is-open');

    /* Close every currently open FAQ */
    document.querySelectorAll('.pa-faq.is-open').forEach(function (f) {
      f.classList.remove('is-open');
      f.querySelector('.pa-faq__btn').setAttribute('aria-expanded', 'false');
    });

    /* Open the clicked one if it was closed */
    if (!isOpen) {
      faq.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {

    /* ── 2. IntersectionObserver — scroll animations ── */
    var animSelectors = '.pa-anim, .pa-anim-fade, .pa-anim-left, .pa-anim-right';
    var animEls = document.querySelectorAll(animSelectors);

    if ('IntersectionObserver' in window && animEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      animEls.forEach(function (el) { io.observe(el); });
    } else {
      animEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ── 3. Reviews counter-up ── */
    var countEl = document.querySelector('[data-countup]');
    if (countEl) {
      var targetStr = countEl.getAttribute('data-countup');
      var target    = parseFloat(targetStr.replace(',', '.'));
      var start     = target - 0.07;
      var duration  = 850;
      var reduce    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var ioCount = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        ioCount.disconnect();

        if (reduce) { countEl.textContent = targetStr; return; }

        var t0 = null;
        requestAnimationFrame(function tick(t) {
          if (!t0) t0 = t;
          var p     = Math.min(1, (t - t0) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          countEl.textContent = (start + (target - start) * eased).toFixed(2).replace('.', ',');
          if (p < 1) requestAnimationFrame(tick);
        });
      }, { threshold: 0.5 });

      ioCount.observe(countEl);
    }

    /* ── 5. Newsletter — validación de email ── */
    var newsForm = document.querySelector('.pa-news__form');
    if (newsForm) {
      var emailRx = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      newsForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = newsForm.querySelector('input[type="email"]');
        var field = newsForm.querySelector('.pa-news__field');
        var msg   = newsForm.querySelector('.pa-news__msg');
        var ok    = emailRx.test((input.value || '').trim());

        field.classList.toggle('is-err', !ok);

        if (!ok) {
          msg.className   = 'pa-news__msg is-err';
          msg.textContent = 'Introduce un email válido para continuar.';
          return;
        }

        msg.className   = 'pa-news__msg is-ok';
        msg.textContent = 'Gracias. Te escribiremos una vez al mes, con criterio.';
        input.value     = '';

        /* Aquí conectar con Klaviyo / Shopify newsletter si aplica:
           fetch('/contact', { method:'POST', body: new FormData(newsForm) }) */
      });

      var emailInput = newsForm.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.addEventListener('input', function () {
          var field = newsForm.querySelector('.pa-news__field');
          var msg   = newsForm.querySelector('.pa-news__msg');
          field.classList.remove('is-err');
          if (msg) { msg.className = 'pa-news__msg'; msg.textContent = ''; }
        });
      }
    }

  }); // end DOMContentLoaded

})();
